import * as React from "react"
const AiSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={45}
    height={45}
    fill="none"
    {...props}
  >
    <circle cx={22.5} cy={22.5} r={22} fill="#fff" stroke="url(#a)" />
    <path
      fill="url(#b)"
      d="m19.012 17.686-1.387 1.386v6.453l1.41 1.409h6.515l1.41-1.409v-6.453l-1.386-1.386H19.012Zm7.23 7.541-.99.991H19.33l-.99-.99v-5.86l.967-.968h5.968l.968.968v5.86Z"
    />
    <path
      fill="url(#c)"
      d="m16.432 14.231-2.358 2.358V28.12l2.4 2.398h11.643l2.4-2.398V16.589l-2.358-2.358H16.432Zm13.37 13.592-1.981 1.98H16.768l-1.98-1.98V16.885l1.94-1.938H27.86l1.94 1.938v10.938Z"
    />
    <path
      fill="url(#d)"
      d="m21.019 20.665-1.25 3.217h.833l.198-.563h1.197l.193.563h.85l-1.234-3.217h-.787Zm.007 2.01.379-1.075.37 1.075h-.749Z"
    />
    <path fill="url(#e)" d="M24.155 20.665h-.811v3.217h.811v-3.217Z" />
    <path
      fill="url(#f)"
      d="M37.53 21.083c-.505 0-.934.33-1.085.785h-4.948v-1.851h1.907c.15.454.58.785 1.084.785.63 0 1.143-.513 1.143-1.142 0-.63-.513-1.143-1.142-1.143-.505 0-.934.329-1.085.785h-1.907v-1.481h3.29l1.12-1.12c.153.08.329.124.513.124.63 0 1.144-.513 1.144-1.143s-.514-1.143-1.144-1.143c-.629 0-1.142.514-1.142 1.143 0 .184.044.359.123.513l-.91.91h-2.994v-1.219l-2.626-2.626h-1.464v-3.079l.91-.91a1.145 1.145 0 0 0 1.657-1.02c0-.63-.513-1.143-1.142-1.143a1.145 1.145 0 0 0-1.02 1.656l-1.12 1.12v3.376h-1.526v-1.992c.454-.15.785-.58.785-1.083 0-.63-.513-1.143-1.143-1.143s-1.143.513-1.143 1.143c0 .504.33.933.785 1.083v1.992h-1.901V8.226c.454-.15.784-.58.784-1.083 0-.63-.513-1.143-1.142-1.143a1.142 1.142 0 0 0-.358 2.226v5.034H19.98v-1.992c.454-.15.785-.58.785-1.083 0-.63-.513-1.143-1.142-1.143a1.142 1.142 0 0 0-.358 2.226v1.992h-1.482V9.884l-1.12-1.12c.079-.154.124-.328.124-.513 0-.63-.513-1.143-1.143-1.143S14.5 7.621 14.5 8.251a1.145 1.145 0 0 0 1.657 1.02l.91.91v3.08h-1.35l-2.626 2.625v1.321h-2.91l-.91-.91c.079-.154.124-.33.124-.513 0-.63-.514-1.143-1.143-1.143-.63 0-1.144.513-1.144 1.143s.514 1.143 1.144 1.143c.184 0 .36-.045.513-.124l1.12 1.12h3.206v1.526h-1.821a1.147 1.147 0 0 0-1.085-.786c-.63 0-1.143.513-1.143 1.143s.514 1.143 1.143 1.143c.504 0 .934-.33 1.085-.786h1.821v1.901H8.227a1.144 1.144 0 0 0-1.084-.784c-.63 0-1.143.513-1.143 1.142a1.142 1.142 0 0 0 2.227.358h4.865v1.85h-1.821a1.146 1.146 0 0 0-1.085-.784c-.63 0-1.143.513-1.143 1.143 0 .629.514 1.143 1.143 1.143.504 0 .934-.33 1.085-.786h1.821v1.48H9.886l-1.12 1.12a1.125 1.125 0 0 0-.513-.123c-.63 0-1.144.514-1.144 1.143 0 .63.514 1.142 1.144 1.142.629 0 1.143-.512 1.143-1.142 0-.184-.045-.36-.124-.513l.91-.91h2.91v1.274l2.672 2.672h1.362v2.874l-.91.91a1.145 1.145 0 0 0-1.657 1.02c0 .63.514 1.143 1.143 1.143.63 0 1.143-.513 1.143-1.143 0-.184-.045-.36-.124-.513l1.12-1.12v-3.17h1.527v1.786c-.455.15-.786.58-.786 1.083 0 .63.514 1.143 1.143 1.143a1.142 1.142 0 0 0 .358-2.226V31.49h1.902v4.83c-.455.15-.786.578-.786 1.082a1.145 1.145 0 0 0 2.287 0c0-.503-.329-.932-.785-1.083V31.49h1.85v1.787c-.453.15-.785.58-.785 1.083 0 .63.514 1.143 1.144 1.143a1.142 1.142 0 0 0 .358-2.226V31.49h1.481v3.17l1.12 1.121a1.124 1.124 0 0 0-.124.513 1.145 1.145 0 0 0 2.287 0 1.145 1.145 0 0 0-1.657-1.02l-.91-.91V31.49h1.361l2.673-2.672V27.44h2.993l.91.91a1.145 1.145 0 0 0 1.02 1.657c.63 0 1.143-.514 1.143-1.143a1.145 1.145 0 0 0-1.657-1.02l-1.12-1.119H31.5V25.2h1.907c.15.454.58.785 1.084.785.63 0 1.143-.514 1.143-1.143a1.144 1.144 0 0 0-2.227-.358h-1.907v-1.901h4.948c.15.454.58.785 1.084.785.63 0 1.144-.513 1.144-1.142 0-.63-.514-1.143-1.144-1.143h-.002Zm-3.041-1.851a.428.428 0 1 1-.001.855.428.428 0 0 1 0-.855Zm1.931-3.975a.427.427 0 1 1 .002.853.427.427 0 0 1-.002-.853Zm-7.59-7.431a.427.427 0 1 1 0 .855.427.427 0 0 1 0-.855Zm-4.022 1.93a.428.428 0 1 1 0 .854.428.428 0 0 1 0-.855ZM22.19 6.714a.428.428 0 1 1-.001.856.428.428 0 0 1 0-.856Zm-2.567 3.04a.428.428 0 1 1-.001.856.428.428 0 0 1 0-.856Zm-4.405-1.504a.427.427 0 1 1 .854 0 .427.427 0 0 1-.854 0Zm-7.392 7.533a.427.427 0 1 1 .854 0 .427.427 0 0 1-.854 0Zm2.359 4.45a.427.427 0 1 1 0-.855.427.427 0 0 1 0 .854Zm-3.043 2.614a.427.427 0 1 1 0-.854.427.427 0 0 1 0 .854Zm3.043 2.568a.427.427 0 1 1 0-.854.427.427 0 0 1 0 .854Zm-1.932 3.976a.428.428 0 1 1 .001-.856.428.428 0 0 1 0 .856Zm7.448 7.326a.427.427 0 1 1-.001-.854.427.427 0 0 1 0 .854Zm4.023-1.93a.428.428 0 1 1 0-.857.428.428 0 0 1 0 .856Zm2.618 3.04a.428.428 0 1 1 0-.856.428.428 0 0 1 0 .856Zm2.567-3.04a.428.428 0 1 1 0-.857.428.428 0 0 1 0 .856Zm4.404 1.503a.427.427 0 1 1-.854 0 .427.427 0 0 1 .854 0Zm7.534-7.428a.427.427 0 1 1-.854 0 .427.427 0 0 1 .854 0Zm-2.36-4.449a.428.428 0 1 1 0 .856.428.428 0 0 1 0-.856Zm-3.706 4.106-2.253 2.255H16.061l-2.254-2.255V16.181l2.208-2.207h12.561l2.206 2.207v12.34Zm6.747-5.87a.427.427 0 1 1 0-.854.427.427 0 0 1 0 .855Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={22.5}
        x2={22.5}
        y1={1}
        y2={44}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5780EA" />
        <stop offset={1} stopColor="#C4698E" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={-30.086}
        x2={81.411}
        y1={22.393}
        y2={22.216}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5780EA" />
        <stop offset={1} stopColor="#C4698E" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={-30.083}
        x2={81.414}
        y1={22.458}
        y2={22.281}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5780EA" />
        <stop offset={1} stopColor="#C4698E" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={-30.085}
        x2={81.413}
        y1={22.356}
        y2={22.177}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5780EA" />
        <stop offset={1} stopColor="#C4698E" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={-30.08}
        x2={81.416}
        y1={22.358}
        y2={22.181}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5780EA" />
        <stop offset={1} stopColor="#C4698E" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={-30.083}
        x2={81.414}
        y1={22.354}
        y2={22.177}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5780EA" />
        <stop offset={1} stopColor="#C4698E" />
      </linearGradient>
    </defs>
  </svg>
)
export default AiSvg
